import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api from "../lib/api";

const MAX_ATTEMPTS = 8;
const INTERVAL_MS = 2500;

export default function ClubBienvenue() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const sessionId = params.get("session_id");
    const [status, setStatus] = useState("checking");
    const [info, setInfo] = useState(null);

    useEffect(() => {
        if (!sessionId) { navigate("/club"); return; }
        let cancelled = false;
        const poll = async (n) => {
            try {
                const r = await api.get(`/checkout/status/${sessionId}`);
                if (cancelled) return;
                if (r.data.payment_status === "paid") {
                    setStatus("paid");
                    if (r.data.email) localStorage.setItem("cp_email", r.data.email);
                    const s = await api.get(`/club/status/${encodeURIComponent(r.data.email)}`);
                    setInfo(s.data);
                    return;
                }
                if (n >= MAX_ATTEMPTS) { setStatus("timeout"); return; }
                setTimeout(() => poll(n + 1), INTERVAL_MS);
            } catch {
                if (n < MAX_ATTEMPTS) setTimeout(() => poll(n + 1), INTERVAL_MS);
                else setStatus("error");
            }
        };
        poll(0);
        return () => { cancelled = true; };
    }, [sessionId, navigate]);

    return (
        <div className="min-h-screen bg-cp-encre text-cp-ivoire flex items-center justify-center px-6 py-20 cp-grain" data-testid="club-bienvenue">
            <div className="max-w-2xl text-center">
                {status === "paid" && info ? (
                    <>
                        <p className="cp-tiny text-cp-sable mb-8">Bienvenue au Cercle</p>
                        <h1 className="cp-serif text-5xl md:text-8xl leading-[0.9] mb-10">
                            Vous êtes <em className="cp-display-italic text-cp-sable">Membre № {info.member_number}</em>.
                        </h1>
                        <p className="cp-serif italic text-xl md:text-2xl text-cp-ivoire/85 mb-12">
                            Formule <em className="cp-display-italic">{info.tier_title}</em> — valide 365 jours.<br />
                            La première Lettre Initiée arrive sous 48h dans votre boîte.
                        </p>
                        <Link to="/scene" className="cp-btn-outline-light">Explorer la Scène →</Link>
                    </>
                ) : (
                    <>
                        <p className="cp-tiny text-cp-sable mb-8">Un instant…</p>
                        <h1 className="cp-serif text-4xl md:text-7xl leading-[0.9] mb-8">
                            Validation du <em className="cp-display-italic text-cp-sable">paiement.</em>
                        </h1>
                        <p className="cp-serif italic text-cp-ivoire/75">Nous préparons votre numéro de membre…</p>
                    </>
                )}
            </div>
        </div>
    );
}
